import { API_ENDPOINT } from './config';

export const urlsAttendance = {
  attendanceEvents: `${API_ENDPOINT}/attendance/events`,
  attendanceEventsDelete: (id) => `${API_ENDPOINT}/attendance/events/${id}`,
  attendanceSchedule: (teacher_id) =>
    `${API_ENDPOINT}/attendance/events/schedule/${teacher_id}`,
  attendanceTeacherSubjectsEvents: (person_id, events, all) =>
    person_id
      ? `${API_ENDPOINT}/attendance/events/schedule/subjects/${person_id}?events=${events}&all=${all}`
      : `${API_ENDPOINT}/attendance/events/schedule/subjects?events=${events}&all=${all}`,
  attendanceEventDetail: (id) => `${API_ENDPOINT}/attendance/events/${id}`,
  attendanceEventByTeacher: (teacher_id) =>
    teacher_id
      ? `${API_ENDPOINT}/attendance/events/teacher/${teacher_id}`
      : `${API_ENDPOINT}/attendance/events/teacher`,
  attendanceExport: (teacher_id) =>
    teacher_id
      ? `${API_ENDPOINT}/attendance/events/export/${teacher_id}`
      : `${API_ENDPOINT}/attendance/events/export`,

  attendance: `${API_ENDPOINT}/attendance/attendance`,
  attendanceDelete: (id) => `${API_ENDPOINT}/attendance/attendance/${id}`,
  attendanceEvent: (att_event_id) =>
    `${API_ENDPOINT}/attendance/attendance/${att_event_id}`,
  attendanceUser: (user_id) =>
    user_id
      ? `${API_ENDPOINT}/attendance/attendance/user/${user_id}`
      : `${API_ENDPOINT}/attendance/attendance/user`,
  attendancePointsToUser: `${API_ENDPOINT}/attendance/attendance/update-user-points`,
  attendanceAddPointsToUsers: `${API_ENDPOINT}/attendance/attendance/update-event-users-points`,
  attendanceUsersForEvents: (teacher_id) =>
    teacher_id
      ? `${API_ENDPOINT}/attendance/attendance/teacher/${teacher_id}`
      : `${API_ENDPOINT}/attendance/attendance/teacher`,
};

export const routesAttendance = {
  // CMS
  cmsAttendanceSchedule: '/cms/attendance-schedule',
  cmsAttendanceEvents: '/cms/attendance-events',
  cmsAttendanceMyEvents: '/cms/attendance-my-events',
  cmsAttendanceCreateCustomEvent: '/cms/attendance-event/create-custom',
  cmsAttendanceCreateScheduleEvent: '/cms/attendance-event/create-schedule',
  cmsAttendanceTeacherOverview: '/cms/attendance-overview/teacher',
  cmsAttendanceStudentOverview: '/cms/attendance-overview/student',
  cmsAttendanceEventDetail: '/cms/attendance-event/detail',
};
